<script setup>
  import { ref } from "vue";
  defineProps({
    visible: { type: Boolean, default: false },
  });
  const emit = defineEmits(['refresh', 'refreshStoresArr', 'update:visible']);
  // import useValidation from '@/utils/helpers/validations';
  import { useCompanyStore } from "@/stores/company";
import { useSitesStore } from "@/stores/sites";
  // import moment from "moment-timezone";

  const sitesStore = useSitesStore();
  // const { checkEmailValidation } = useValidation();
  const company_id = useCompanyStore().companyId;
  // const store_id = ref(null);
  const name = ref(null);
  const contact_email = ref(null);
  // const timezone = ref(null);
  // let timeZoneNames = ref([]);
  let location = ref(null);
  let isValidEmail = ref(true);
  let isSubmitted = ref(false);

  // onBeforeMount(()=>{
  //   timeZoneNames = moment.tz.names();
  // });

  const resetData = () => {
    // store_id.value = null;
    name.value = null;
    contact_email.value = null;
    // timezone.value = null;
    location.value = null;
    isValidEmail.value = true;
    isSubmitted.value = false;
  };

  const closeAndReset = () => {
    resetData();
    emit('update:visible', false);
  };

  // const validEmail = () => {
  //   isValidEmail.value = checkEmailValidation(contact_email.value);
  //   return isValidEmail.value;
  // };

  const onSubmit = () => {
    isSubmitted.value = true;
    const data = { 
      // store_id : store_id.value, 
      name : name.value,
      location : location.value, 
      // contact_email :contact_email.value, 
      // timezone : timezone.value, 
      company_id 
    };
    sitesStore.addSite(data).then(() => {
      emit('refreshStoresArr');
      emit('refresh');
      closeAndReset();
    }).catch( () => {
      isSubmitted.value = false;
    });
  }
</script>
<template>
  <DModal :visible="visible" @update:visible="val => { if (!val) closeAndReset() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Add New Site </template>
    
    <template #body>

      <!-- <div class="form-floating mb-3">
        <input v-model.trim="store_id" type="text" class="form-control" id="storeId" placeholder="Store ID" />
        <label for="storeId">Store ID</label>
      </div> -->

      <div class="mb-3">
        <DInput :value="name" @input="name = $event.target.value" label="Site Name" width="100%" />
      </div>

      <!-- <div class="form-floating mb-3"> 
        <input @input="validEmail" v-model="contact_email"  type="email" :class="{'is-invalid' : !isValidEmail}" class="form-control" id="contactEmail" placeholder="Contact Email" />
        <label for="contactEmail">Contact Email</label> 
        <div v-if="!isValidEmail" class="invalid-feedback">
          Invalid Email.
        </div>
      </div> -->

      <!-- <div class="relative"> 
        <span v-if="timezone" class="multiselect-title-span">Time Zone</span>
        <VMultiselect v-model="timezone" :options="timeZoneNames" :disabled="!timeZoneNames.length" :loading="!timeZoneNames.length" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Time Zone" />
      </div> -->

      <div class="mb-3">
        <DInput :value="location" @input="location = $event.target.value" label="Location" width="100%" />
      </div>

      <div class="seperator"></div>
    </template>

    <template #footer>
      <button :disabled="!name || !location || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button">Add
        <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
      </button>
      <button @click="closeAndReset" type="button" class="btn btn-secondary cancel-button">Cancel</button>
    </template>
  </DModal>
</template>
